import type { SVGProps } from 'react';
import * as React from 'react';

const ExclamationTriangleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="outline/exclamation-triangle">
      <path
        id="Icon"
        d="M11.9998 9.7475V13.4975M2.69653 16.8731C1.83114 18.3731 2.91371 20.2475 4.64544 20.2475H19.3541C21.0858 20.2475 22.1684 18.3731 21.303 16.8731L13.9487 4.12562C13.0828 2.62479 10.9167 2.62479 10.0509 4.12562L2.69653 16.8731ZM11.9998 16.4975H12.0073V16.505H11.9998V16.4975Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default ExclamationTriangleIcon;
